var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filename === 'EventToday')?_c('event-today'):(_vm.filename === 'dashboard')?_c('dashboard'):_c('error404')
}
var staticRenderFns = []

export { render, staticRenderFns }